module.exports = __webpack_public_path__ + "img/bt_map_full_screen_default.04685592.svg";